export const CARACTERISTICA_CLIENTE_LOAD = "CARACTERISTICA_CLIENTE_LOAD";
export const CARACTERISTICA_CLIENTE_LIST = "CARACTERISTICA_CLIENTE_LIST";
export const CARACTERISTICA_CLIENTE_CREATE = "CARACTERISTICA_CLIENTE_CREATE";
export const CARACTERISTICA_CLIENTE_UPDATE = "CARACTERISTICA_CLIENTE_UPDATE";
export const CARACTERISTICA_CLIENTE_DELETE = "CARACTERISTICA_CLIENTE_DELETE";
